import useLocale from 'next-translate/useTranslation';

export default function AgentLifecycle() {
  const { t } = useLocale('chatbots');

  const steps = [
    {
      number: '01',
      title: t('Train'),
      description: t(
        'Import your website, help docs, PDFs, Notion pages, and YouTube videos. Your agent learns your business in minutes — no code required.',
      ),
    },
    {
      number: '02',
      title: t('Test'),
      description: t(
        'Chat with your agent in the playground before going live. Compare AI models, tune instructions, and validate answers against real customer questions.',
      ),
    },
    {
      number: '03',
      title: t('Deploy'),
      description: t(
        'Publish everywhere with one click: your website, WhatsApp, Messenger, Telegram, Slack — and a phone number customers can call.',
      ),
    },
    {
      number: '04',
      title: t('Improve'),
      description: t(
        'Review conversations, track analytics and daily summaries, capture leads, and refine instructions. Your agent gets better every week.',
      ),
    },
  ];

  return (
    <section className='bg-gray-50 py-24 dark:bg-slate-800 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='lg:grid lg:grid-cols-3 lg:gap-x-16'>
          <div className='lg:sticky lg:top-24 lg:self-start'>
            <h2 className='text-sm font-bold uppercase tracking-wider text-primary-600 dark:text-primary-400'>
              {t('From zero to agent')}
            </h2>
            <p className='mt-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white sm:text-4xl'>
              {t('Live in an afternoon, not a quarter')}
            </p>
            <p className='mt-4 text-lg leading-8 text-gray-600 dark:text-slate-300'>
              {t(
                'Four steps between your data and a working agent your customers can talk to.',
              )}
            </p>
          </div>

          <div className='mt-16 lg:col-span-2 lg:mt-0'>
            <ol className='divide-y divide-gray-200 border-y border-gray-200 dark:divide-white/10 dark:border-white/10'>
              {steps.map((step) => (
                <li
                  key={step.number}
                  className='group grid grid-cols-[4.5rem_1fr] gap-x-6 py-10 sm:grid-cols-[7rem_1fr] sm:gap-x-10'
                >
                  <span className='font-serif text-4xl italic leading-none text-gray-300 transition-colors group-hover:text-primary-500 dark:text-slate-600 dark:group-hover:text-primary-400 sm:text-5xl'>
                    {step.number}
                  </span>
                  <div>
                    <h3 className='text-xl font-bold text-gray-900 dark:text-white'>
                      {step.title}
                    </h3>
                    <p className='mt-3 max-w-xl text-base leading-relaxed text-gray-600 dark:text-slate-400'>
                      {step.description}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
